<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field
        dense
        label="Courriel"
        v-model="email"
        filled
        :rules="[requiredRule(), serverRule('infos.email')]"
        @input="notify('infos.email')"
        persistent-hint
        hint="Cette adresse sera utilisée pour valider votre compte, et vous permettra de vous identifier."
        data-testid="email"
      />
    </v-col>
    <v-col cols="12">
      <a-motpasse-field
        dense
        label="Mot de passe"
        v-model="motPasse"
        filled
        :rules="[requiredRule(), serverRule('motPasse')]"
        @input="notify('infos.motPasse')"
        hint="Au moins 10 caractères, dont une majuscule et un caractère spécial."
        counter
        data-testid="mot-de-passe"
      />
    </v-col>
    <v-col cols="12">
      <a-civilite-select
        dense
        label="Civilité"
        v-model="civilite"
        filled
        :rules="[requiredRule(), serverRule('infos.civilite')]"
        @input="notify('infos.civilite')"
        data-testid="civilite"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Nom"
        v-model="nom"
        filled
        :rules="[requiredRule(), serverRule('infos.nom')]"
        @input="notify('infos.nom')"
        data-testid="nom"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Prénom"
        v-model="prenom"
        filled
        :rules="[requiredRule(), serverRule('infos.prenom')]"
        @input="notify('infos.prenom')"
        data-testid="prenom"
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        dense
        label="Adresse"
        v-model="adresse"
        filled
        :rules="[serverRule('infos.adresse')]"
        @input="notify('infos.adresse')"
        placeholder="Facultatif"
        data-testid="adresse"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Complément d'adresse"
        v-model="complementAdresse"
        filled
        :rules="[serverRule('infos.complementAdresse')]"
        @input="notify('infos.complementAdresse')"
        placeholder="Facultatif"
        data-testid="complement-adresse"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Code postal"
        v-model="codePostal"
        filled
        :rules="[serverRule('infos.codePostal')]"
        @input="notify('infos.codePostal')"
        placeholder="Facultatif"
        data-testid="code-postal"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Commune"
        v-model="ville"
        filled
        :rules="[serverRule('infos.ville')]"
        @input="notify('infos.ville')"
        placeholder="Facultatif"
        data-testid="commune"
      />
    </v-col>
  </v-row>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";

function mapTo(src, dest) {
  dest.motPasse = src.motPasse;
  dest.nom = src.nom;
  dest.prenom = src.prenom;
  dest.email = src.email;
  dest.civilite = src.civilite;
  dest.adresse = src.adresse;
  dest.complementAdresse = src.complementAdresse;
  dest.codePostal = src.codePostal;
  dest.ville = src.ville;
}

export default {
  mixins: [makeRules(), makeValueData(mapTo), ValueDataRules],
};
</script>
